export default __webpack_public_path__ + "static/media/hornbill-festival.0b0f9112.pdf";